module.exports = function () {
  return "\n    <div class=\"explorers-overlay\" id=\"explorers-overlay\">\n    </div>\n  ";
};